import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FeedbackDialogComponent } from '../feedback-dialog/feedback-dialog.component';

@Component({
  selector: 'app-feedback-button',
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './feedback-button.component.html',
  styleUrls: ['./feedback-button.component.scss'],
})
export class FeedbackButtonComponent {
  private dialog = inject(MatDialog);

  openFeedback(): void {
    this.dialog.open(FeedbackDialogComponent, {
      width: '560px',
      maxWidth: '95vw',
      autoFocus: false,
      restoreFocus: true,
      disableClose: true,
    });
  }
}
